module.exports = __webpack_public_path__ + "img/info-2.30a82f32.svg";